/**
 * MiniStat — shared 3-up grid cell used inside ActiveRideCard and
 * PendingOfferCard.
 *
 * Was duplicated locally inside both card files during slices 1 + 2
 * because the parent Driver.jsx originally owned the only copy. Now
 * that both consumers live under components/driver/, hoisting the
 * helper here is safe (the legacy duplicate had already been removed
 * from Driver.jsx in slice 2's tidy step).
 *
 * Pure presentational — no state, no effects, no derived values.
 *
 * Rollback: paste the 7-line definition back into ActiveRideCard.jsx
 * AND PendingOfferCard.jsx, remove the import, delete this file.
 */
import React from "react";

export function MiniStat({ icon, label, value }) {
  return (
    <div className="bg-white border border-border p-2">
      <div className="label-mini text-muted-foreground flex items-center gap-1">
        {icon} {label}
      </div>
      <div className="font-heading font-black text-sm mt-0.5">{value}</div>
    </div>
  );
}
